<ng-container *ngIf="showLoading">
  <div class="overlay" [style.background-color]="background_color">
    <mat-progress-bar [color]="color" [mode]="mode"></mat-progress-bar>
  </div>
</ng-container>
